module.exports = "<div>\n  <span [ngClass]=\"flagClasses()\"></span>\n  <span id=\"code\" *ngIf=\"showCode\">{{code}}</span>\n</div>\n"